import { axios } from './axios';

/**
 * fetch all tracking records function.
 *
 * @param {Object} params request body.
 * @return {Promise<import("axios").AxiosResponse>} return axios response.
 */
export const fetchTrackingRecords = async ({
    pageNo,
    limit,
    sortBy,
    sortField,
    content_type,
    start_date,
    end_date,
    big_ref_no,
    customer_email,
    user_plan,
    keywords,
}) => {
    var params = `?pageNo=${pageNo}&limit=${limit}&sortBy=${sortBy}&sortField=${sortField}`;

    if (content_type) params += `&content_type=${content_type}`;
    if (start_date) params += `&start_date=${start_date}`;
    if (end_date) params += `&end_date=${end_date}`;
    if (big_ref_no) params += `&big_ref_no=${big_ref_no}`;
    if (customer_email) params += `&customer_email=${customer_email}`;
    if (user_plan) params += `&user_plan=${user_plan}`;
    if (keywords) params += `&keywords=${keywords}`;

    return await axios.get('/tracking/list' + params);
};

/**
 * Export tracking data function.
 *
 * @param {Object} body
 * @param {string} [body.start_date]
 * @param {string} [body.end_date]
 * @param {string} [body.content_type]
 * @param {string} [body.big_ref_no]
 * @param {string} [body.customer_email]
 * @param {string} [body.user_plan]
 * @returns {Promise<import("axios").AxiosResponse>} return axios response.
 */
export const exportTrackingData = async (body) => {
    var params = '?';
    if (body.start_date) params += `start_date=${body.start_date}&`;
    if (body.end_date) params += `end_date=${body.end_date}&`;
    if (body.content_type) params += `content_type=${body.content_type}&`;
    if (body.big_ref_no) params += `big_ref_no=${body.big_ref_no}&`;
    if (body.customer_email) params += `customer_email=${body.customer_email}&`;
    if (body.user_plan) params += `user_plan=${body.user_plan}&`;

    return await axios.get('/tracking/export' + params.slice(0, -1));
};
